import { render, staticRenderFns } from "./CommentPage.vue?vue&type=template&id=86e9d7a2&scoped=true"
import script from "./CommentPage.vue?vue&type=script&lang=js"
export * from "./CommentPage.vue?vue&type=script&lang=js"
import style0 from "./CommentPage.vue?vue&type=style&index=0&id=86e9d7a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e9d7a2",
  null
  
)

export default component.exports